const { pick, keyBy, groupBy, mapValues, } = require('lodash');

const { filterByModelType, } = require('./models/changeField');

const { keys, entries } = Object;

const changeTypeSpecs = [
  ['cash', '現金及び現金同等物'],
  ['fixedAsset', '固定資産', true],
  ['fixedAssetRelatedItem', '固定資産に係る債権債務・売却損益'],
  ['investment', '投資その他', true],
  ['investmentRelatedItem', '投資に係る債権債務・売却損益'],
  ['fixedDeposit', '定期預金', true],
  ['loan', '外部貸付', true],
  ['incomeInterestItem', '未収利息・前受利息'],
  ['otherLiability', 'その他負債', true],
  ['debt', '外部借入', true],
  ['bond', '社債', true],
  ['expenseInterestItem', '未払利息・前払利息'],
  ['capital', '資本', true],
  ['treasuryStock', '自己株式', true],
  ['stockOption', '新株予約権', true],
  ['allowance', '引当金', true],
];

// keptChangeTypes: 非表示にされていても選択肢として残すchangeTypeキー(既に仕訳で使われている値)
const buildChangeTypes = (customChangeFields = [], ordersByModelType = {}, keptChangeTypes = []) => {
  const keptKeysByModelType = mapValues(groupBy(keptChangeTypes.filter(_ => _), _ => _.split('__')[0]), _ => _.map(_ => _.split('__')[1]).filter(_ => _));
  return keyBy(
    changeTypeSpecs.map(_ => ({
      key: _[0],
      label: _[1],
      ...(_[2] && pick(require(`./models/${_[0]}`), ['changeFieldNames', 'fields'])),
    })).flatMap(({ key, label, changeFieldNames, fields }) => {
      if (!changeFieldNames) return [{ label, key, }];
      const customs = filterByModelType(customChangeFields, key);
      const savedOrder = ordersByModelType[key]?.keys;
      const keptKeys = keptKeysByModelType[key] || [];
      const hiddenKeys = (ordersByModelType[key]?.hiddenKeys || []).filter(_ => !keptKeys.includes(_));
      const names = changeFieldNames(customs, savedOrder, hiddenKeys);
      const f = fields({ customChangeFields: customs, savedOrder, hiddenKeys });
      return names.map(_ => ({ label: `${label} > ${f[_].label}`, key: `${key}__${_}`, }));
    }),
    'key',
  );
};

const buildChangeTypeOptions = (customChangeFields = [], ordersByModelType = {}, keptChangeTypes = []) => {
  return entries(buildChangeTypes(customChangeFields, ordersByModelType, keptChangeTypes)).map(([k, v]) => ({ label: v.label, value: k, }));
};

const changeTypes = buildChangeTypes();
const changeTypeOptions = buildChangeTypeOptions();

exports.buildChangeTypes = buildChangeTypes;
exports.buildChangeTypeOptions = buildChangeTypeOptions;
exports.changeTypes = changeTypes;
exports.changeTypeOptions = changeTypeOptions;
